<template>
<div>
    <div class="col">
        <div class="ibox sombra-light">
            <div class="ibox-title">
                <h5>
                    Grupos de Workers (Supervisor)
                    <span v-if="pendiente" class="badge badge-warning ml-2" title="El cambio se aplicará automáticamente en el próximo ciclo">
                        <i class="fal fa-clock"></i> Cambios pendientes de aplicar
                    </span>
                    <span v-else class="badge badge-success ml-2">
                        <i class="fal fa-check"></i> Configuración al día
                    </span>
                </h5>
                <div class="ibox-tools">
                    <button class="btn btn-default btn-sm" @click="importar" :disabled="cargando">
                        <i class="fal fa-download"></i> Importar
                    </button>
                    <button class="btn btn-info btn-sm" @click="previsualizar" :disabled="cargando || grupos.length === 0">
                        <i class="fal fa-eye"></i> Previsualizar
                    </button>
                    <button class="btn-primary btn btn-sm" @click="agregar">
                        <i class="fal fa-plus"></i> Agregar
                    </button>
                </div>
            </div>
            <div class="ibox-content">
                <div v-if="grupos.length === 0" class="alert alert-warning text-center">
                    <strong>Sin configuración cargada.</strong>
                    Usa <em>Importar configuración actual</em> o crea el primer grupo.
                </div>

                <data-table v-else :id="dt.id" :datos="dt.datos" :columnas="dt.columnas" :responsive="true" :font-size="12">
                    <template v-slot:colas_slot="item">
                        <span v-for="(cola, i) in item.data.colas" :key="i" class="badge badge-primary mr-1">
                            {{ i + 1 }}. {{ cola }}
                        </span>
                    </template>
                    <template v-slot:activo_slot="item">
                        <span :class="item.data.activo ? 'badge badge-success' : 'badge badge-secondary'">
                            {{ item.data.activo ? 'Sí' : 'No' }}
                        </span>
                    </template>
                    <template v-slot:opciones="item">
                        <div class="dropdown float-right">
                            <button class="btn btn-gray btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Opciones
                            </button>
                            <ul class="dropdown-menu dropdown-menu-right">
                                <li>
                                    <a href="javascript:void(0)" @click="editar(item.data)">
                                        <i class="fal fa-edit"></i> Editar
                                    </a>
                                    <a href="javascript:void(0)" @click="eliminar(item.data.id)">
                                        <i class="fal fa-trash-alt"></i> Eliminar
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </template>
                </data-table>
            </div>
        </div>
    </div>

    <FormModal ref="FormModal" :tipo="tipo" :grupo="seleccionado" @guardar="guardar"></FormModal>
    <ModalDelete ref="ModalDelete" @eliminar="borrar"></ModalDelete>
</div>
</template>

<script>
import axios from 'axios';
import DataTable from '../DataTableLuis.vue';
import FormModal from './FormModal.vue';
import ModalDelete from './delete.vue';

export default {
    props: {
        grupos_iniciales: { type: Array, default: () => [] },
        base: { type: String, default: '/admin/configurar/grupos-workers' },
        pendiente_inicial: { type: Boolean, default: false },
    },
    components: { DataTable, FormModal, ModalDelete },
    data() {
        return {
            grupos: [],
            pendiente: false,
            dt: {
                id: 'grupos-workers',
                columnas: [
                    { nombre: 'Orden', nombre_variable: 'orden' },
                    { nombre: 'Nombre', nombre_variable: 'nombre' },
                    { nombre: 'Colas (por prioridad)', nombre_variable: 'colas_slot', slot: 1 },
                    { nombre: 'Procesos', nombre_variable: 'procesos' },
                    { nombre: 'Activo', nombre_variable: 'activo_slot', slot: 1 },
                    { nombre: 'Opciones', nombre_variable: 'opciones', slot: 1 },
                ],
                datos: [],
            },
            tipo: 'Agregar',
            seleccionado: null,
            idEliminar: null,
            cargando: false,
        };
    },
    mounted() {
        this.grupos = Array.isArray(this.grupos_iniciales) ? this.grupos_iniciales.slice() : [];
        this.pendiente = !!this.pendiente_inicial;
        this.refrescarTabla();
    },
    methods: {
        refrescarTabla() {
            this.dt.datos = [];
            setTimeout(() => {
                this.dt.datos = this.grupos;
            }, 300);
        },
        agregar() {
            this.tipo = 'Agregar';
            this.seleccionado = null;
            this.$refs.FormModal.show(null);
        },
        editar(grupo) {
            this.tipo = 'Editar';
            this.seleccionado = grupo;
            this.$refs.FormModal.show(grupo);
        },
        guardar(payload) {
            const esEditar = this.tipo === 'Editar' && this.seleccionado;
            const url = esEditar ? this.base + '/' + this.seleccionado.id : this.base;
            const metodo = esEditar ? 'patch' : 'post';

            axios[metodo](url, payload).then(response => {
                const grupo = response.data;
                if (esEditar) {
                    const idx = this.grupos.findIndex(g => g.id === grupo.id);
                    if (idx !== -1) this.$set(this.grupos, idx, grupo);
                } else {
                    this.grupos.push(grupo);
                }
                this.$refs.FormModal.hide();
                this.refrescarTabla();
                this.pendiente = true;
                this.notificar('success', esEditar ? 'Grupo actualizado.' : 'Grupo creado.');
            }).catch(error => {
                this.notificarErrorValidacion(error);
            });
        },
        eliminar(id) {
            this.idEliminar = id;
            this.$refs.ModalDelete.show();
        },
        borrar() {
            axios.delete(this.base + '/' + this.idEliminar).then(() => {
                this.grupos = this.grupos.filter(g => g.id !== this.idEliminar);
                this.idEliminar = null;
                this.refrescarTabla();
                this.pendiente = true;
                this.notificar('success', 'Grupo eliminado.');
            }).catch(() => {
                this.notificar('error', 'No se pudo eliminar el grupo.');
            });
        },
        importar() {
            this.$swal.fire({
                title: 'Importar configuración',
                html: 'Carga la configuración a la base de datos:<br>'
                    + 'usa el archivo de la instancia y, si no existe, el archivo central (primera vez).<br>'
                    + '<small>No genera archivos: los cambios se aplican solos en el próximo ciclo.</small>',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Continuar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#6c757d',
            }).then(result => {
                if (!result.value) return;
                this.cargando = true;
                axios.post(this.base + '/importar-actual').then(response => {
                    this.grupos = response.data.grupos || [];
                    this.refrescarTabla();
                    if (this.grupos.length > 0) this.pendiente = true;
                    this.notificar('success', response.data.message || 'Configuración importada.');
                }).catch(error => {
                    const msg = error.response && error.response.data ? error.response.data.message : 'Error al importar.';
                    this.notificar('error', msg);
                }).then(() => {
                    this.cargando = false;
                });
            });
        },
        previsualizar() {
            this.cargando = true;
            axios.get(this.base + '/previsualizar').then(response => {
                const data = response.data;
                const aviso = data.path_configurado
                    ? '<small>Se escribiría en: <code>' + data.path + '</code></small>'
                    : '<small class="text-danger">⚠️ SUPERVISOR_CONF_PATH no configurado — "Aplicar" no escribirá hasta definirlo.</small>';
                this.$swal.fire({
                    title: 'Previsualización (no se aplica nada)',
                    html: aviso + '<pre style="text-align:left;max-height:340px;overflow:auto;margin-top:10px">'
                        + this.escapar(data.contenido) + '</pre>',
                    width: 800,
                    confirmButtonText: 'Cerrar',
                });
            }).catch(error => {
                const msg = error.response && error.response.data ? error.response.data.message : 'No se pudo previsualizar.';
                this.notificar('error', msg);
            }).then(() => {
                this.cargando = false;
            });
        },
        escapar(texto) {
            return (texto || '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
        },
        notificar(icon, title) {
            this.$swal.fire({ position: 'center', icon: icon, title: title, showConfirmButton: false, timer: 1500 });
        },
        notificarErrorValidacion(error) {
            let texto = 'No se pudo guardar el grupo.';
            if (error.response && error.response.status === 422 && error.response.data.errors) {
                const errores = error.response.data.errors;
                texto = Object.keys(errores).map(k => errores[k][0]).join('<br>');
            }
            this.$swal.fire({ icon: 'error', title: 'Revisa los datos', html: texto });
        },
    },
};
</script>
